module.exports = __webpack_public_path__ + "img/beyondwire.dff50302.png";